export default function initializeCheckoutNipValidation() {
    const checkoutBlock = document.querySelector('[data-block-name="woocommerce/checkout"]');
    if (!checkoutBlock) return;

    new CheckoutNipValidationClass(checkoutBlock);
}

class CheckoutNipValidationClass {
    constructor(block) {
        this.block = block;

        this.ERR_ID = 'venti-nip';
        this._rafScheduled = false;

        this.initWhenReady();
    }

    initWhenReady() {
        // wc/store/validation може з’явитися трохи пізніше
        let tries = 0;
        const timer = setInterval(() => {
            tries++;

            this.validationStore = window?.wc?.wcBlocksData?.validationStore;
            this.wpData = window?.wp?.data;

            if (this.validationStore && this.wpData?.dispatch) {
                clearInterval(timer);
                this.init();
                return;
            }

            // щоб не крутити вічно
            if (tries >= 100) clearInterval(timer);
        }, 50);
    }

    init() {
        const dispatch = this.wpData.dispatch(this.validationStore);
        this.setValidationErrors = dispatch.setValidationErrors;
        this.clearValidationErrors = dispatch.clearValidationErrors;

        this.bindEvents();
        this.observeDom();
        this.scheduleValidate();
    }

    // --- selectors ---
    getCompanyInput() {
        // беремо перший знайдений (частіше billing)
        return this.block.querySelector('#billing-company, #shipping-company');
    }

    getNipInput() {
        return this.block.querySelector(
            '#billing-thwcfe-block-billing_nip,' +
            '#shipping-thwcfe-block-billing_nip,' +
            'input[name$="thwcfe-block/billing_nip"]'
        );
    }

    // --- scheduling (anti-freeze) ---
    scheduleValidate() {
        if (this._rafScheduled) return;
        this._rafScheduled = true;

        requestAnimationFrame(() => {
            this._rafScheduled = false;
            this.validate();
        });
    }

    // --- blocks store error (blocks submit) ---
    setError(message) {
        this.setValidationErrors({
            [this.ERR_ID]: { message, hidden: true },
        });
    }

    clearError() {
        this.clearValidationErrors([this.ERR_ID]);
    }

    // --- inline error (DOM), but WITHOUT infinite loop ---
    renderFieldError(inputEl, message) {
        const wrap = inputEl.closest('.wc-block-components-text-input');
        if (!wrap) return;

        const idBase = inputEl.name
            ? inputEl.name.replace(/[^a-z0-9_-]/gi, '_')
            : (inputEl.id || 'nip');

        const errId = `validate-error-${idBase}`;

        // якщо вже та сама помилка — нічого не міняємо (менше мутацій)
        const existing = wrap.querySelector('.wc-block-components-validation-error p span');
        if (existing && existing.textContent === message && wrap.classList.contains('has-error')) {
            return;
        }

        wrap.classList.add('has-error');
        inputEl.setAttribute('aria-invalid', 'true');
        inputEl.setAttribute('aria-errormessage', errId);

        let err = wrap.querySelector('.wc-block-components-validation-error');
        if (!err) {
            err = document.createElement('div');
            err.className = 'wc-block-components-validation-error';
            err.setAttribute('role', 'alert');
            // маркер, щоб observer міг ігнорувати наші вставки
            err.dataset.ventiInjected = '1';
            wrap.appendChild(err);
        }

        err.innerHTML = `<p id="${errId}"><span>${message}</span></p>`;
    }

    clearFieldError(inputEl) {
        const wrap = inputEl.closest('.wc-block-components-text-input');
        if (!wrap) return;

        // якщо вже нема помилки — не чіпаємо DOM
        if (!wrap.classList.contains('has-error')) return;

        wrap.classList.remove('has-error');
        inputEl.setAttribute('aria-invalid', 'false');
        inputEl.removeAttribute('aria-errormessage');

        const err = wrap.querySelector('.wc-block-components-validation-error');
        if (err) err.remove();
    }

    // --- main validation ---
    validate() {
        const companyEl = this.getCompanyInput();
        const nipEl = this.getNipInput();
        if (!companyEl || !nipEl) return;

        const company = (companyEl.value || '').trim();
        const nipRaw  = (nipEl.value || '').trim();

        // default clear
        this.clearError();
        this.clearFieldError(nipEl);

        if (company === '' && nipRaw !== '') {
            const msg = 'Nie można podać NIP bez nazwy firmy.';
            this.setError(msg);
            this.renderFieldError(nipEl, msg);
            return;
        }

        if (company !== '' && nipRaw === '') {
            const msg = 'NIP jest wymagany przy podaniu nazwy firmy.';
            this.setError(msg);
            this.renderFieldError(nipEl, msg);
            return;
        }

        if (nipRaw !== '' && !/^\d+$/.test(nipRaw)) {
            const msg = 'NIP może zawierać wyłącznie cyfry.';
            this.setError(msg);
            this.renderFieldError(nipEl, msg);
            return;
        }

        if (nipRaw !== '' && nipRaw.length !== 10) {
            const msg = 'NIP musi mieć 10 cyfr.';
            this.setError(msg);
            this.renderFieldError(nipEl, msg);
            return;
        }
    }

    // --- events ---
    bindEvents() {
        this.block.addEventListener('input', (e) => {
            const t = e.target;
            if (!t) return;

            if (
                t.matches('#billing-company, #shipping-company') ||
                t.matches('#billing-thwcfe-block-billing_nip, #shipping-thwcfe-block-billing_nip') ||
                (t.name && t.name.endsWith('thwcfe-block/billing_nip'))
            ) {
                this.scheduleValidate();
            }
        });
    }

    observeDom() {
        this.observer = new MutationObserver((mutations) => {
            // ігноруємо мутації, які спричинили наші інжекти помилок
            for (const m of mutations) {
                const target = m.target;

                // якщо мутація всередині нашого validation-error — пропускаємо
                if (target && target.closest && target.closest('[data-venti-injected="1"]')) {
                    continue;
                }

                // якщо додали/прибрали інпут або checkout перерендерив — перевалідуємо
                if (m.type === 'childList') {
                    this.scheduleValidate();
                    return;
                }
            }
        });

        // слухаємо тільки checkout block, а не весь документ
        this.observer.observe(this.block, { childList: true, subtree: true });
    }
}
